import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()((theme, { height, width })=>({
        player: {
            display: 'block',
            width: width ? width : '100%',
            height: height ? height : '100%'
        }
    }));
export { useStyles };
